import { render, staticRenderFns } from "./UserKartei.vue?vue&type=template&id=24d1fae6&scoped=true"
import script from "./UserKartei.vue?vue&type=script&lang=js"
export * from "./UserKartei.vue?vue&type=script&lang=js"
import style0 from "./UserKartei.vue?vue&type=style&index=0&id=24d1fae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1fae6",
  null
  
)

export default component.exports